<template>
    <span :data-toggle="isTruncated ? 'tooltip-text' : null"
          :data-original-title="isTruncated ? normalized : null"
          data-placement="top">{{ displayed }}</span>
</template>

<script>
// Odpowiednik layouts.site.parts.truncated-text dla Vue: tekst dluzszy niz
// max_length jest przycinany do poczatku + "…" (wielokropek wliczony w limit),
// a pelna tresc pokazuje tooltip po najechaniu na caly tekst.
// Tooltip stawia delegacja data-toggle="tooltip-text" z layouts.site.base
// (zawsze jako zwykly tekst, takze dla wierszy dorenderowanych pozniej).
import TableCellText from "../services/TableCellText";

const ELLIPSIS = '…';

export default {
    name: "TruncatedText",
    props: {
        text: {default: ''},
        max_length: {type: [Number, String], required: true}
    },
    computed: {
        normalized: function () {
            return TableCellText.normalize(this.text);
        },
        limit: function () {
            return parseInt(this.max_length, 10);
        },
        isTruncated: function () {
            return this.normalized.length > this.limit;
        },
        displayed: function () {
            if (!this.isTruncated) {
                return this.normalized;
            }

            return this.normalized.substring(0, this.limit - 1).trimEnd() + ELLIPSIS;
        }
    },
    beforeDestroy: function () {
        // dymek otwarty nad usuwanym wierszem zostalby w <body>
        const $el = $(this.$el);
        if ($el.data('bs.tooltip')) {
            $el.tooltip('dispose');
        }
    }
}
</script>
